import type { SiteType, Trait, TraitsForContext } from '../types';

export const getSiteTraitValues = (traits: Trait[]): TraitsForContext => {
	if (traits.length === 0) {
		return {
			siteType: null,
			automationUsage: 0,
			lastAutomationFreeLimitBreachDate: null,
		};
	}

	const siteTypeTrait = traits.find((trait) => trait.name === 'growth_discount_cohort');
	const automationUsageTrait = traits.find(
		(trait) => trait.name === 'growth_automation_limits_usage',
	);
	const lastAutomationFreeLimitBreachDateTrait = traits.find(
		(trait) => trait.name === 'growth_automation_limits_usage_latest_breach_date',
	);

	let siteType = null;
	if (siteTypeTrait) {
		if (siteTypeTrait.value === 'EDU' || siteTypeTrait.value === 'ORG') {
			siteType = siteTypeTrait.value as SiteType;
		} else {
			siteType = 'UNKNOWN' as SiteType;
		}
	}

	const automationUsage =
		automationUsageTrait &&
		automationUsageTrait.value !== undefined &&
		!isNaN(Number(automationUsageTrait.value))
			? Number(automationUsageTrait.value)
			: 0;

	const lastAutomationFreeLimitBreachDate =
		lastAutomationFreeLimitBreachDateTrait &&
		typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' &&
		!isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value))
			? new Date(lastAutomationFreeLimitBreachDateTrait.value)
			: null;

	return {
		siteType,
		automationUsage,
		lastAutomationFreeLimitBreachDate,
	};
};
